import { BaseDto } from '@up/data';

export class FireTransactionDto extends BaseDto {
  treasuryTransactionTypeId?: number;
  ican?: number;
  businessEntityId?: number;
  businessEntityBankId?: number;
  txnId?: number;
  date: Date;
  source?: string;
  description?: string;
  amount?: number;
  balance?: number;
  amountDirection?: 'CREDIT' | 'DEBIT';
  transferId?: string;
  additionalData?: any;
}
